import { ProductDetailPage } from '@/components/products/product-detail-page';
import { nextonveraProduct } from '@/content/products';

export function NextOnVeraPage() {
  return <ProductDetailPage product={nextonveraProduct} />;
}
